function getEnvVar<T = string>(key: keyof ImportMetaEnv, fallback?: T): T {
    const value = import.meta.env[key];

    if (value === undefined || value === null) {
        if (fallback !== undefined) {
            return fallback;
        }

        throw new Error(`Missing environment variable: ${ key }`);
    }

    return value as unknown as T;
}

export const ENV = {
    NODE_ENV: import.meta.env.MODE,
    API_URL: getEnvVar('VITE_DEDICARE_BACKEND_URL', 'https://staffing-be-dev.azurewebsites.net'),
    B2C_CLIENT_ID: getEnvVar('VITE_AZURE_AUTH_APP_CLIENT_ID'),
    B2C_TENANT_NAME: getEnvVar('VITE_AZURE_B2C_TENANT_NAME'),
    B2C_CUSTOM_DOMAIN: getEnvVar<string | null>('VITE_AZURE_B2C_CUSTOM_DOMAIN', null),
    PRIVACY_LINK: getEnvVar<string>('VITE_PRIVACY_LINK'),
    CLARITY_ID: getEnvVar<string | null>('VITE_CLARITY_ID', null),
    GA_ID: getEnvVar<string | null>('VITE_GA_ID', null),
    POSTHOG_TOKEN: getEnvVar<string | null>('VITE_POSTHOG_TOKEN', null),
    POSTHOG_HOST: getEnvVar<string>('VITE_POSTHOG_HOST', 'https://eu.i.posthog.com'),
    OLD_PORTAL_URL: getEnvVar<string>('VITE_OLD_PORTAL_URL')
} as const;
